import React from 'react';
import { HiddenInput, StyledLabel } from './styles';
import { Row } from 'styled-bootstrap-grid';
import Icon from '../Icon'

const FileObtInput = ({
  id, 
  onChange, 
  uploadLabel, 
  state, 
  ...props 
}) => {
  return (
    <>
      <HiddenInput
        type="file"
        id={id} 
        onChange={onChange} 
        accept="image/*" 
      />
       <StyledLabel 
        htmlFor={id} 
        state={state}
        {...props}
      >
        {uploadLabel || 'Seleccionar archivo'}
      </StyledLabel>
    
    </>
  );
};

export default FileObtInput; 